import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { useFormikContext } from 'formik';

import FormList from 'core/components/form-list';
import FormSectionWrapper from 'common/components/form-section-wrapper';
import Property from './property';
import AddProperty from './add-property';

import useStyles from './properties-form.styles';

const PropertyForm = ({ id, propertyType }) => {
  const { values } = useFormikContext();

  const isRentalProperty = propertyType === 'rental';
  const properties = isRentalProperty
    ? values.umbrellaCoverage?.rentalPropertyAddresses || []
    : values.umbrellaCoverage?.otherPropertyAddresses || [];

  const sectionTitle = isRentalProperty ? 'Rental properties' : 'Additional residences (Non-Rental properties)';
  const totalLabel = isRentalProperty ? 'Rental properties' : 'Additional residences';
  const emptyStateTitle = isRentalProperty
    ? 'There are no rental properties added yet'
    : 'There are no additional residences added yet';

  return (
    <FormSectionWrapper
      sectionTitle={sectionTitle}
      totalLabel={totalLabel}
      totalCount={properties?.length || 0}
      emptyStateTitle={emptyStateTitle}
      isEmpty={properties?.length === 0}
    >
      <FormList id={id} item={Property} addForm={AddProperty} showRightLabel={false} propertyType={propertyType} />
    </FormSectionWrapper>
  );
};

function PropertiesForm({ id }) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <h1 className={classes.sectionTitle}>Properties</h1>
      <Grid container className={classes.propertyFormContainer}>
        <PropertyForm sectionTitle="Rental properties" id={`${id}.rentalPropertyAddresses`} propertyType="rental" />
      </Grid>
      <Grid container className={classes.propertyFormContainer}>
        <PropertyForm
          sectionTitle="Additional residences (Non-Rental properties)"
          id={`${id}.otherPropertyAddresses`}
          propertyType="nonRental"
        />
      </Grid>
    </div>
  );
}

PropertiesForm.propTypes = {
  id: PropTypes.string.isRequired
};

export default PropertiesForm;
